import React from 'react'
import Link from 'gatsby-link'

import styles from './Popup.module.css'
import FieldDefinitions from '../data/FieldDefinitions'

import PopupEinrichtung from './PopupEinrichtung'

class Popup extends React.Component {
  constructor(props) {
    super(props)
    this.escFunction = this.escFunction.bind(this)

    this.state = {
      menu: props.menu ? props.menu : 0,
    }
  }

  escFunction(event) {
    if (event.keyCode === 27) {
      this.props.closePopup()
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false)
  }

  switchMenu = value => {
    this.setState({ menu: value })
  }

  render() {
    return (
      <div className={styles.box}>
        <div className={styles.header}>
          <span>{this.props.data.gemeinde.name}</span>
          <div className={styles.x} onClick={() => this.props.closePopup()}>
            <svg width="20" height="20">
              <line
                x1="5"
                y1="5"
                x2="15"
                y2="15"
                stroke="#BE0021"
                strokeWidth="3"
                strokeLinecap="butt"
              />
              <line
                x1="15"
                y1="5"
                x2="5"
                y2="15"
                stroke="#BE0021"
                strokeWidth="3"
                strokeLinecap="butt"
              />
            </svg>
          </div>
        </div>

        {this.state.menu == 0 ? (
          <div className={styles.text}>
            <a
              href={
                this.props.data.zusatzGemeinden.edges[0].node.Website_Gemeinde
              }
            >
              {this.props.data.zusatzGemeinden.edges[0].node.Website_Gemeinde}
            </a>
            <br />
            <table className={styles.indicator}>
              <tbody>
                <tr>
                  <th>Kategorie VIF-Indikator:</th>
                  <td>{this.props.data.gemeinde.VIF_Kategorie}</td>
                </tr>
              </tbody>
            </table>
            <hr />
            <table className={styles.indicator + ' ' + styles.count}>
              <tbody>
                <tr>
                  <th>Anzahl der Betreuungseinrichtungen</th>
                  <td />
                </tr>
                <tr>
                  <td>Krippe</td>
                  <td>{this.props.data.gemeinde.Anz_Krippe || 0}</td>
                </tr>
                <tr>
                  <td>Kindergarten</td>
                  <td>{this.props.data.gemeinde.Anz_KiGa || 0}</td>
                </tr>
                <tr>
                  <td>alterserweiterter Kindergarten</td>
                  <td>{this.props.data.gemeinde.Anz_alterserw_KiGa || 0}</td>
                </tr>
                <tr>
                  <td>Hort</td>
                  <td>{this.props.data.gemeinde.Anz_Hort || 0}</td>
                </tr>
                <tr>
                  <td>Nachmittagsbetreuung in Volksschulen</td>
                  <td>{this.props.data.gemeinde.schulischeNMB_VS_Ki || 0}</td>
                </tr>
              </tbody>
            </table>
            <hr />
            <table className={styles.indicator}>
              <tbody>
                <tr>
                  <th>Betreuung für unter 3-jährige Kinder</th>
                  <td />
                </tr>
                <tr>
                  <td>Tagesöffnungszeiten</td>
                  <td>
                    {this.props.data.gemeinde.oeffTag_0_3J
                      ? FieldDefinitions['oeffTag_0_3J'].values[
                          this.props.data.gemeinde.oeffTag_0_3J
                        ].label
                      : null}
                  </td>
                </tr>
                <tr>
                  <td>Wochenöffnungszeiten</td>
                  <td>
                    {this.props.data.gemeinde.oeffWoche_0_3J
                      ? FieldDefinitions['oeffWoche_0_3J'].values[
                          this.props.data.gemeinde.oeffWoche_0_3J
                        ].label
                      : null}
                  </td>
                </tr>
                <tr>
                  <td>Schließtage im Jahr</td>
                  <td>
                    {this.props.data.gemeinde.geschlJahr_0_3J
                      ? FieldDefinitions['geschlJahr_0_3J'].values[
                          this.props.data.gemeinde.geschlJahr_0_3J
                        ].label
                      : null}
                  </td>
                </tr>
                <tr>
                  <td>Mittagessen</td>
                  <td>{this.props.data.gemeinde.Mittagessen_0_3}</td>
                </tr>
              </tbody>
            </table>
            <hr />
            <table className={styles.indicator}>
              <tbody>
                <tr>
                  <th>Betreuung für 3- bis 6-jährige Kinder</th>
                  <td />
                </tr>
                <tr>
                  <td>Tagesöffnungszeiten</td>
                  <td>
                    {this.props.data.gemeinde.oeffTag_3_6J
                      ? FieldDefinitions['oeffTag_3_6J'].values[
                          this.props.data.gemeinde.oeffTag_3_6J
                        ].label
                      : null}
                  </td>
                </tr>
                <tr>
                  <td>Wochenöffnungszeiten</td>
                  <td>
                    {this.props.data.gemeinde.oeffWoche_3_6J
                      ? FieldDefinitions['oeffWoche_3_6J'].values[
                          this.props.data.gemeinde.oeffWoche_3_6J
                        ].label
                      : null}
                  </td>
                </tr>
                <tr>
                  <td>Schließtage im Jahr</td>
                  <td>
                    {this.props.data.gemeinde.geschlJahr_3_6J
                      ? FieldDefinitions['geschlJahr_3_6J'].values[
                          this.props.data.gemeinde.geschlJahr_3_6J
                        ].label
                      : null}
                  </td>
                </tr>
                <tr>
                  <td>Mittagessen</td>
                  <td>{this.props.data.gemeinde.Mittagessen_3_6}</td>
                </tr>
              </tbody>
            </table>
            <hr />
            <table className={styles.indicator}>
              <tbody>
                <tr>
                  <th>Nachmittagsbetreuung für Volksschulkinder</th>
                  <td>{this.props.data.gemeinde.VS_Ki_NMB}</td>
                </tr>
              </tbody>
            </table>
            <div>
              <hr />
              <table className={styles.indicator}>
                <tbody>
                  <tr>
                    <th style={{ fontWeight: 'bold', paddingLeft: '-2px' }}>
                      Gemeindekooperationen
                    </th>
                    <td />
                  </tr>
                  <tr>
                    <td>Betreuung für unter-3-jährige Kinder</td>
                    <td>
                      {this.props.data.kooperationen.edges.find(
                        k => this.props.data.gemeinde.iso === k.node.iso
                      ).node.koop_u3J_GEM ? (
                        <a
                          href="#"
                          onClick={() =>
                            this.props.openPopup(
                              this.props.data.kooperationen.edges.find(
                                k => this.props.data.gemeinde.iso === k.node.iso
                              ).node.koop_u3J_GEM
                            )}
                        >
                          {this.props.data.alleGemeinden.edges.find(
                            k =>
                              this.props.data.kooperationen.edges.find(
                                k => this.props.data.gemeinde.iso === k.node.iso
                              ).node.koop_u3J_GEM === k.node.iso
                          ).node.name +
                            ' (' +
                            this.props.data.alleGemeinden.edges.find(
                              k =>
                                this.props.data.kooperationen.edges.find(
                                  k =>
                                    this.props.data.gemeinde.iso === k.node.iso
                                ).node.koop_u3J_GEM === k.node.iso
                            ).node.VIF_Kategorie +
                            ')'}
                        </a>
                      ) : (
                        '-'
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Betreuung für 3-6-jährige Kinder</td>
                    <td>
                      {this.props.data.kooperationen.edges.find(
                        k => this.props.data.gemeinde.iso === k.node.iso
                      ).node.koop_3_6J_GEM ? (
                        <a
                          href="#"
                          onClick={() =>
                            this.props.openPopup(
                              this.props.data.kooperationen.edges.find(
                                k => this.props.data.gemeinde.iso === k.node.iso
                              ).node.koop_3_6J_GEM
                            )}
                        >
                          {this.props.data.alleGemeinden.edges.find(
                            k =>
                              this.props.data.kooperationen.edges.find(
                                k => this.props.data.gemeinde.iso === k.node.iso
                              ).node.koop_3_6J_GEM === k.node.iso
                          ).node.name +
                            ' (' +
                            this.props.data.alleGemeinden.edges.find(
                              k =>
                                this.props.data.kooperationen.edges.find(
                                  k =>
                                    this.props.data.gemeinde.iso === k.node.iso
                                ).node.koop_3_6J_GEM === k.node.iso
                            ).node.VIF_Kategorie +
                            ')'}
                        </a>
                      ) : (
                        '-'
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>Betreuung für Volksschulkinder</td>
                    <td>
                      {this.props.data.kooperationen.edges.find(
                        k => this.props.data.gemeinde.iso === k.node.iso
                      ).node.koop_NMB_GEM ? (
                        <a
                          href="#"
                          onClick={() =>
                            this.props.openPopup(
                              this.props.data.kooperationen.edges.find(
                                k => this.props.data.gemeinde.iso === k.node.iso
                              ).node.koop_NMB_GEM
                            )}
                        >
                          {this.props.data.alleGemeinden.edges.find(
                            k =>
                              this.props.data.kooperationen.edges.find(
                                k => this.props.data.gemeinde.iso === k.node.iso
                              ).node.koop_NMB_GEM === k.node.iso
                          ).node.name +
                            ' (' +
                            this.props.data.alleGemeinden.edges.find(
                              k =>
                                this.props.data.kooperationen.edges.find(
                                  k =>
                                    this.props.data.gemeinde.iso === k.node.iso
                                ).node.koop_NMB_GEM === k.node.iso
                            ).node.VIF_Kategorie +
                            ')'}
                        </a>
                      ) : (
                        '-'
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            {this.props.data.zusatzGemeinden.edges[0].node.Zusatzinfo && (
              <div>
                <hr />
                <span className={styles.fillerText}>
                  Zusätzliche Information:
                </span>
                {` ${this.props.data.zusatzGemeinden.edges[0].node.Zusatzinfo}`}
              </div>
            )}
            <br />
            <a
              style={{ cursor: 'pointer', fontWeight: 'bold' }}
              onClick={() => this.setState({ menu: 1 })}
            >
              &gt; &gt; &gt; zu den einzelnen Betreuungseinrichtungen
            </a>
            <br />
            Quelle: Amt der Burgenländischen Landesregierung,
            Kindertagesheimstatistik 2024/2025; Gemeindekooperationen:
            telefonische Erhebung bei den Gemeindeämtern im Oktober 2017
          </div>
        ) : null}
        {this.state.menu == 1 ? (
          <PopupEinrichtung
            switchMenu={this.switchMenu}
            data={this.props.data}
            openPopup={this.props.openPopup}
          />
        ) : null}
      </div>
    )
  }
}

export default Popup



// WEBPACK FOOTER //
// ./src/components/Popup.js